import React from 'react';
import { View, StyleSheet } from 'react-native';
import { rem } from 'design-system/values';
import IconPlus from 'design-system/icons/IconPlus';
import IconCircle from 'design-system/icons/IconCircle';
import { SettingsItem } from 'design-system/SettingsItem';
import useColors from 'hooks/useColors';
const CreateNewWatchListBtn = ({ onPress }) => {
    const colors = useColors();
    return (<SettingsItem style={styles.createNewListButton} renderIcon={() => (<View style={styles.iconContainer}>
          <IconCircle width={44} height={44}>
            <IconPlus color={colors.text.brand}/>
          </IconCircle>
        </View>)} title="Create new list" onPress={onPress}/>);
};
export default CreateNewWatchListBtn;
const styles = StyleSheet.create({
    createNewListButton: {
        margin: 0,
        padding: rem(16),
    },
    iconContainer: {
        marginRight: rem(16),
    },
});
